<template>
  <div class="hero-container">
    <!-- Cabecera -->
    <div class="top-bar">
      <div class="textos">
        <div class="header">

          <h1 class="titulo">Trabaja con millones de colores</h1>
          <img src="@/assets/logo.png" alt="HP y RM" class="logo-central" />
        </div>
        <div class="linea-subtitulo">
          <hr />
          <p>Espera más de una impresora</p>
          <hr />
        </div>
      </div>
    </div>

    <!-- Imágenes lado a lado -->
    <div class="main-images">
      <img src="@/assets/rm-jugadores.png" class="img-left" />
      <img src="@/assets/mujer-impresora.png" class="img-right" />
    </div>

    <!-- Botón inferior -->
    <div class="bottom-bar">
      <div class="start-linea">
        <!-- <hr /> -->
        <button class="start-button" @click="iniciarApp">Iniciar</button>
        <!-- <hr /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    iniciarApp() {
      this.$router.push('/seleccion-genero');
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('generateTokens');
    } catch (error) {
      alert('Error al generar los tokens. Intente nuevamente.');
    }
  },
};
</script>

<style lang="scss" scoped>
.hero-container {
  background-color: #0095d9;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'FormaDJRDisplay', sans-serif;
  overflow: hidden;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2rem 0 1rem 0;
  color: white;
}

.textos {
  flex: 1;
  .header {
    display: flex;
    padding: 0 2rem 0 2rem;
    justify-content: space-between;
  }
  .titulo {
    font-size: 6rem;
    // font-weight: bold;
    max-width: 800px;
    letter-spacing: 3px;
    text-align: left;
    margin: 0;
    line-height: 1;
  }

  .linea-subtitulo {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 0.5rem;
    gap: 1rem;
    text-align: left;
    
    hr {
      flex: 1;
      border: none;
      min-height: 1px;
      min-width: 100%;
      background-color: white;
    }

    p {
      margin: 0;
      font-size: 2rem;
      white-space: nowrap;
      letter-spacing: 1px;
      width: 100%;
      line-height: 0.5;
      padding: 0 2rem;
    }
  }
}

.logo-central {
  height: 180px;
  margin-left: 2rem;
}

.main-images {
  display: flex;
  flex: 1;
  img {
    width: 50%;
    height: auto;
    object-fit: cover;
  }
}

.bottom-bar {
  text-align: center;
  // padding: 0.5rem 2rem 1.5rem 2rem;
}

.start-linea {
  display: flex;
  align-items: center;
  // gap: 1rem;

  hr {
    flex: 1;
    border: none;
    height: 1px;
    background-color: white;
  }

  .start-button {
    background-color: transparent;
    color: white;
    font-size: 1.1rem;
    border: none;
    display: block;
    width: 100%;
    padding: 1rem 2rem;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    letter-spacing: 1px;
    &:hover {
      background-color: white;
      color: #0095d9;
    }
  }
}
</style>
